import React from 'react';
import { Callout, CalloutProps } from './Callout';

export const Info: React.FC<Omit<CalloutProps, 'type'>> = (props) => (
  <Callout type="info" {...props} />
);

export default Info;
